import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  webSocketResponse: {},
  webSocketMessage: "",
  webSocketClient: {}
};

const websocketSlice = createSlice({
  name: "websocket",
  initialState,
  reducers: {
    setwebSocketResponse: (state, action) => {
      state.webSocketResponse = action.payload;
    },
    setWebSocketMessage: (state, action) => {
      state.webSocketMessage = action.payload;
    },
    setWebSocketClient: (state, action) => {
      state.webSocketClient = action.payload;
    },
    resetWebSocketResponse: (state) => {
      state.webSocketResponse = {};
    },
    clearWebSocketMessage: (state) => {
      state.webSocketMessage = "";
    },
  },
});

export const {
  setwebSocketResponse,
  setWebSocketMessage,
  resetWebSocketResponse,
  setWebSocketClient,
  clearWebSocketMessage
} = websocketSlice.actions;

export default websocketSlice.reducer;
